import { NavigationItem } from '@/type/Navigation'

export function useXpressBottomNavigation() {
  const navigationItems: NavigationItem[] = [
    {
      icon: 'home-outline',
      activeIcon: 'home',
      label: 'หน้าแรก',
      to: 'XpressProfile',
      active: false,
    },
    {
      icon: 'gift-outline',
      activeIcon: 'gift-open',
      label: 'รางวัล',
      to: 'XpressRedeem',
      active: false,
    },
    {
      icon: 'calendar-blank',
      activeIcon: 'calendar-check',
      label: 'นัดหมาย',
      to: 'XpressAppointment', // Shared route
      active: false,
    },
  ]

  function getNavigationItems() {
    return navigationItems
  }

  return {
    getNavigationItems,
  }
}
